export default {"src":"/_next/static/media/lined-broccoli.32fe2723.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};